export default "__VITE_ASSET__BmztGa8V__"